import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    fr: {
        translation: {
            "Welcome to": "Bienvenue sur",
            "Guess the": "Devinez le",
            "song titles": "titre des chansons",
            "from the lyrics": "à partir des paroles",
            "The more titles you find": "Plus vous trouvez de titres",
            "the more trophies you earn": "plus vous gagnez des trophées",
            "and unlock new songs": "et débloquez de nouvelles chansons",
            "Available game modes": "Modes de jeu disponibles",
            "Classic Mode": "Mode Classique",
            "Find the": "Trouvez le",
            "Once found, switch to": "Une fois trouvé, passez en",
            "Hardcore Mode": "Mode Hardcore",
            "and guess all the lyrics": "et devinez toutes les paroles",
            "to earn bonus points": "pour gagner des points bonus",
            "NOPLP Mode": "Mode NOPLP",
            "Select a song from the database": "Sélectionnez une chanson dans la base de données",
            "and try to find": "et tentez de retrouver",
            "all the lyrics": "toutes les paroles",
            "The more you find": "Plus vous en trouvez",
            "the more points you score": "plus vous marquez de points",
            "Settings": "Paramètres",
            "Autoplay": "Lecture automatique",
            "Theme": "Thème",
            "Play now": "Jouer maintenant",
            "Click to stop singing": "Cliquez pour arrêter de chanter",
            "Click to sing the song": "Cliquez pour chanter la chanson",
            "Try": "Essai",
            "Give up": "Abandon",
            "Are you sure you want to give up?":"Es-tu sûr de vouloir abandonner ?",
            "Give up Hardcore": "Abandon Hardcore",
            "Let's go Hardcore": "Tenter Hardcore",
            "Reset DB": "Réinitialiser la BD",
            "Made with ❤️ for Charline": "Réalisé avec ❤️ pour Charline",
            "Wow, champion!": "Wow, champioooon !",
            "You crushed the song in hardcore mode!": "Tu as déchiré la chanson en mode hardcore !",
            "Well done!": "Bravo !",
            "You found the song!": "Tu as trouvé la chanson !",
            "Filters": "Filtres",
            "Language": "Langue",
            "French": "Français",
            "Italian": "Italien",
            "English": "Anglais",
            "Decades": "Décennies",
            "Style": "Style",
            "Song status": "État de la chanson",
            "Unlocked": "Débloquées",
            "Not found": "Non trouvées",
            "Found (hardcore)": "Trouvées (hardcore)",
            "Found (normal)": "Trouvées (normal)",
            "Abandoned": "Abandonnées",
            "Previous guesses": "Essais précédents",
            "Continue in hardcore mode to try to discover all the lyrics and earn more points?": "Continuer en mode hardcore pour essayer de découvrir toutes les paroles et gagner plus de points ?",
            "Hardcore mode": "Mode Hardcore",
            "Yes": "Oui",
            "No": "Non",
            "Choose a song to start playing": "Choisissez une chanson pour commencer à jouer",
            "Buy": "Acheter",
            "for": "pour",
            "Type to search...": "Tapez pour rechercher...",
            "Song search": "Recherche de chansons",
            "Songs in progress": "Chansons en cours",
            "No songs in progress.": "Aucune chanson en cours.",
            "Completed songs": "Chansons complétées",
            "No completed songs.": "Aucune chanson complétée.",
            "Classic": "Classique",
            "NOPLP": "NOPLP",
            "Songs": "Chansons",
            "No songs found." : "Aucune chanson trouvée.",
            "You need": "Il vous manque",
            "trophies": "trophées",
            "trophy": "trophée",
            "and": "et",
            "song": "chanson",
            "to unlock": "pour débloquer",
            "French Classics": "Classiques français",
            "French Youtube": "Youtube français",
            "Rock": "Rock",
            "Pop": "Pop",
            "Rap": "Rap",
            "Disney Songs": "Chansons Disney",
            "Save DB": "Sauvegarder la BD",
            "Load DB": "Charger la BD",
            "Voice recognition not supported": "Reconnaissance vocale non supportée",
            "Semantic": "Sémantique",
            "Syntactic": "Syntaxique",
            "Enter a room id and a name": "Entrez un id de salle et un nom",
            "Please enter a room id and a name": "Veuillez entrer un id de salle et un nom",
            "Waiting for Peer initialization...": "En attente de l'initialisation du Peer...",
            "This name is already taken, please choose another one": "Ce nom est déjà pris, veuillez en choisir un autre",
            "Connected to a room, waiting for players...": "Connecté au salon, en attente de joueurs...",
            "Disconnected" : "Déconnecté",
            "Connected" : "Connecté",
            "Successfully Disconnected" : "Déconnecté avec succès",
            "You have been removed from the room" : "Vous avez été retiré de la salle",
            "New player detected" : "Nouveau joueur détecté",
            "has joined the room" : "a rejoint la salle",
            "Multiplayer connection" : "Connexion multijoueur",
            "Room ID" : "ID du salon",
            "Your name" : "Votre nom",
            "Join a room" : "Rejoindre un salon",
            "Disconnect" : "Se déconnecter",
            "Status" : "Statut",
            "Room players" : "Joueurs dans le salon",
            "Close" : "Fermer",
            "No other players connected" : "Aucun autre joueur connecté",
            "Send guess list" : "Envoyer la liste des essais",
            "Go to same song" : "Aller à la même chanson",
            'Click to go to -> mode: ' : 'Cliquez pour aller à -> mode: ',
            "classic" : "classique",
            "Available Rooms" : "Salons disponibles",
            "No open rooms" : "Aucun salon ouvert",
            "Battle" : "Combat",
            "Room" : "Salon",
            "Victory" : "Victoire",
            "Defeat" : "Défaite",
            "Tie" : "Égalité",
            "You" : "Vous",
            " against " : " contre ",
            "waiting" : "en attente",
            "fighting" : "en combat",
            "victory" : "victoire",
            "defeat" : "défaite",
            "tie" : "égalité",
            "not_participating" : "abstention",
            "1v1 Battle" : "Combat 1v1",
            "You need to be connected to start a battle." : "Vous devez être connecté pour commencer un combat.",
            "Battle against your friends! The first to find the song title wins trophies." : "Combattez vos amis ! Le premier à trouver le titre de la chanson gagne des trophées.",
            "Ready to battle!" : "Prêt à combattre !",
            "Not participating" : "S'abstenir",
            "ready" : "prêt",
            "Match in progress!" : "Match en cours !",
            "Time elapsed:" : "Temps écoulé :",
            "Ask for a tie" : "Proposer un match nul",
            "Previous fights" : "Combats précédents",
            "No finished fights yet." : "Aucun combat terminé.",
            " (You)" : " (Vous)",
            "players" : "joueurs",
            "player" : "joueur",
            "Number of players" : "Nombre de joueurs",
            "Oh no..." : "Oh non...",
            "You lost this time, but don't give up!" : "Vous avez perdu cette fois, mais ne baissez pas les bras !",
            "It's a tie!" : "C'est un match nul !",
            "A well-matched battle! No winners, no losers." : "Un combat bien équilibré ! Pas de gagnant, pas de perdant.",
            "Ready up to start the battle" : "Mettez-vous prêt pour commencer le combat",
            "Invite your friends to " : "Invitez vos amis pour ",
            "help you out" : "vous aider",
            "and play together" : "et jouer ensemble",
            "You can also challenge them in" : "Vous pouvez aussi les défier en",
            "Battle Mode" : "Mode Combat",
            "to steal their trophies" : "pour leur voler leurs trophées",
            "Challenge your friends in a musical duel" : "Défiez vos amis dans un duel musical",
            "Be the first to find the" : "Soyez le premier à trouver le",
            "to win the battle and steal trophies" : "pour gagner le combat et voler des trophées",
            "The first to find the song title wins trophies." : "Le premier à trouver le titre de la chanson gagne des trophées.",
            "Random choice among" : "Choix aléatoire parmi",
            "songs" : "chansons",
            "Uncheck some filters to get more songs!" : "Décochez certains filtres pour obtenir plus de chansons !",
            "Correct answer" : "Bonne réponse",
            "Wrong answer" : "Mauvaise réponse",
            "Attempts remaining" : "Essais restants",
            "Correct word!" : "Mot correct !",
            "Artist" : "Artiste",
            "Title" : "Titre",
            "found" : "trouvé",
            "Enter a word..." : "Entrez un mot...",
            "Validate" : "Valider",
            "Skip" : "Passer",
            "Correct answer!" : "Bonne réponse !",
            "Now identify the real artists" : "Maintenant identifiez les vrais artistes",
            "Your Name" : "Votre Nom",
            "Quiz finished!" : "Quiz terminé !",
            "You scored" : "Vous avez marqué",
            "Compare your score with other players!" : "Comparez votre score avec les autres joueurs !",
            "Leaderboard" : "Classement",
            "Please enter a name" : "Veuillez entrer un nom",
            "The name is already in use" : "Le nom est déjà utilisé",
            "Score saved!" : "Score sauvegardé !",
            "No scores available for today." : "Aucun score disponible pour aujourd'hui.",
            "Daily Podium" : "Podium du Jour",
            "words" : "mots",
            "Other players" : "Autres joueurs",
            "Today's song" : "Chanson du jour",
            "Find today's song to unlock the quiz!" : "Trouvez la chanson du jour pour débloquer le quiz !",
            "Today's quiz" : "Quiz du jour",
            "Streak (Consecutive days)" : "Jours consécutifs",
            "Days played" : "Jours joués",
            "Max score" : "Score max",
            "Average score" : "Score moyen",
            "Average words" : "Mots moyens",
            "Personal History" : "Historique Personnel",
            "No history available." : "Aucun historique disponible.",
            "Home" : "Accueil",
            "History" : "Historique",
            "Total score: " : "Score total : ",
            "Your Statistics" : "Vos Statistiques",
            "What is the release year of this song?" : "Quelle est l'année de sortie de cette chanson ?",
            "What is the album of this song?" : "Quel est l'album de cette chanson ?",
            "What is the birth year of the artist?" : "Quelle est l'année de naissance de l'artiste ?",
            "What is the death year of the artist?" : "Quelle est l'année de décès de l'artiste ?",
            "What is the formation year of the band?" : "Quelle est l'année de formation du groupe ?",
            "What is the disbandment year of the band?" : "Quelle est l'année de séparation du groupe ?",
            "Which country is this artist from?" : "De quel pays est originaire cet artiste ?",
            "What are the most popular songs of this artist?" : "Quelles sont les chansons les plus populaires de cet artiste ?",
            "Find the two intruder songs" : "Trouvez les deux chansons intruses",
            "Daily" : "Daily",
            "place_1" : "1er",
            "place_2" : "2ème",
            "place_3" : "3ème",
            "place_other" : "{{place}}ème",
            "Each day, find the song of the day in as few tries as possible" : "Chaque jour, trouvez la chanson du jour avec le moins de mots possible",
            "Once found, take a quiz about the artist to earn bonus points" : "Une fois trouvée, passez un quiz sur l'artiste pour gagner des points bonus",
            "Compare your score with others and check the daily leaderboard" : "Comparez votre score avec les autres et consultez le classement quotidien",
            "Daily Mode" : "Mode Daily",
        },
    },
    en: {
        translation: {
            "Welcome to": "Welcome to",
            "Guess the": "Guess the",
            "song titles": "song titles",
            "from the lyrics": "from the lyrics",
            "The more titles you find": "The more titles you find",
            "the more trophies you earn": "the more trophies you earn",
            "and unlock new songs": "and unlock new songs",
            "Available game modes": "Available game modes",
            "Classic Mode": "Classic Mode",
            "Find the": "Find the",
            "Once found, switch to": "Once found, switch to",
            "Hardcore Mode": "Hardcore Mode",
            "and guess all the lyrics": "and guess all the lyrics",
            "to earn bonus points": "to earn bonus points",
            "NOPLP Mode": "NOPLP Mode",
            "Select a song from the database": "Select a song from the database",
            "and try to find": "and try to find",
            "all the lyrics": "all the lyrics",
            "The more you find": "The more you find",
            "the more points you score": "the more points you score",
            "Settings": "Settings",
            "Autoplay": "Autoplay",
            "Theme": "Theme",
            "Play now": "Play now",
            "Click to stop singing": "Click to stop singing",
            "Click to sing the song": "Click to sing the song",
            "Try": "Try",
            "Give up": "Give up",
            "Are you sure you want to give up?":"Are you sure you want to give up?",
            "Give up Hardcore": "Give up Hardcore",
            "Let's go Hardcore": "Let's go Hardcore",
            "Reset DB": "Reset DB",
            "Made with ❤️ for Charline": "Made with ❤️ for Charline",
            "Wow, champion!": "Wow, champion!",
            "You crushed the song in hardcore mode!": "You crushed the song in hardcore mode!",
            "Well done!": "Well done!",
            "You found the song!": "You found the song!",
            "Filters": "Filters",
            "Language": "Language",
            "French": "French",
            "Italian": "Italian",
            "English": "English",
            "Decades": "Decades",
            "Style": "Style",
            "Song status": "Song status",
            "Unlocked": "Unlocked",
            "Not found": "Not found",
            "Found (hardcore)": "Found (hardcore)",
            "Found (normal)": "Found (normal)",
            "Abandoned": "Abandoned",
            "Previous guesses": "Previous guesses",
            "Continue in hardcore mode to try to discover all the lyrics and earn more points?": "Continue in hardcore mode to try to discover all the lyrics and earn more points?",
            "Hardcore mode": "Hardcore mode",
            "Yes": "Yes",
            "No": "No",
            "Choose a song to start playing": "Choose a song to start playing",
            "Buy": "Buy",
            "for": "for",
            "Type to search...": "Type to search...",
            "Song search": "Song search",
            "Songs in progress": "Songs in progress",
            "No songs in progress.": "No songs in progress.",
            "Completed songs": "Completed songs",
            "No completed songs.": "No completed songs.",
            "Classic": "Classic",
            "NOPLP": "NOPLP",
            "Songs": "Songs",
            "No songs found." : "No songs found.",
            "You need": "You need",
            "trophies": "trophies",
            "trophy": "trophy",
            "and": "and",
            "song": "song",
            "to unlock": "to unlock",
            "French Classics": "French Classics",
            "French Youtube": "French Youtube",
            "Rock": "Rock",
            "Pop": "Pop",
            "Rap": "Rap",
            "Disney Songs": "Disney Songs",
            "Save DB": "Save DB",
            "Load DB": "Load DB",
            "Voice recognition not supported": "Voice recognition not supported",
            "Semantic": "Semantic",
            "Syntactic": "Syntactic",
            "Enter a room id and a name": "Enter a room id and a name",
            "Please enter a room id and a name": "Please enter a room id and a name",
            "Waiting for Peer initialization...": "Waiting for Peer initialization...",
            "This name is already taken, please choose another one": "This name is already taken, please choose another one",
            "Connected to a room, waiting for players...": "Connected to a room, waiting for players...",
            "Disconnected" : "Disconnected",
            "Connected" : "Connected",
            "Successfully Disconnected" : "Successfully Disconnected",
            "You have been removed from the room" : "You have been removed from the room",
            "New player detected" : "New player detected",
            "has joined the room" : "has joined the room",
            "Multiplayer connection" : "Multiplayer connection",
            "Room ID" : "Room ID",
            "Your name" : "Your name",
            "Join a room" : "Join a room",
            "Disconnect" : "Disconnect",
            "Status" : "Status",
            "Room players" : "Room players",
            "Close" : "Close",
            "No other players connected" : "No other players connected",
            "Send guess list" : "Send guess list",
            "Go to same song" : "Go to same song",
            "classic" : "classic",
            "Available Rooms" : "Available Rooms",
            "No open rooms" : "No open rooms",
            "Battle" : "Battle",
            "Room" : "Room",
            "Victory" : "Victory",
            "Defeat" : "Defeat",
            "Tie" : "Tie",
            "You" : "You",
            " against " : " against ",
            "waiting" : "waiting",
            "fighting" : "fighting",
            "victory" : "victory",
            "defeat" : "defeat",
            "tie" : "tie",
            "not_participating" : "not participating",
            "1v1 Battle" : "1v1 Battle",
            "You need to be connected to start a battle." : "You need to be connected to start a battle.",
            "Battle against your friends! The first to find the song title wins trophies." : "Battle against your friends! The first to find the song title wins trophies.",
            "Ready to battle!" : "Ready to battle!",
            "Not participating" : "Not participating",
            "ready" : "ready",
            "Match in progress!" : "Match in progress!",
            "Time elapsed:" : "Time elapsed:",
            "Ask for a tie" : "Ask for a tie",
            "Previous fights" : "Previous fights",
            "No finished fights yet." : "No finished fights yet.",
            " (You)" : " (You)",
            "players" : "players",
            "player" : "player",
            "Number of players" : "Number of players",
            "Oh no..." : "Oh no...",
            "You lost this time, but don't give up!" : "You lost this time, but don't give up!",
            "It's a tie!" : "It's a tie!",
            "A well-matched battle! No winners, no losers." : "A well-matched battle! No winners, no losers.",
            "Ready up to start the battle" : "Ready up to start the battle",
            "Invite your friends to " : "Invite your friends to ",
            "help you out" : "help you out",
            "and play together" : "and play together",
            "You can also challenge them in" : "You can also challenge them in",
            "Battle Mode" : "Battle Mode",
            "to steal their trophies" : "to steal their trophies",
            "Challenge your friends in a musical duel" : "Challenge your friends in a musical duel",
            "Be the first to find the" : "Be the first to find the",
            "to win the battle and steal trophies" : "to win the battle and steal trophies",
            "The first to find the song title wins trophies." : "The first to find the song title wins trophies.",
            "Random choice among" : "Random choice among",
            "songs" : "songs",
            "Uncheck some filters to get more songs!" : "Uncheck some filters to get more songs!",
            "Correct answer" : "Correct answer",
            "Wrong answer" : "Wrong answer",
            "Attempts remaining" : "Attempts remaining",
            "Correct word!" : "Correct word!",
            "Artist" : "Artist",
            "Title" : "Title",
            "found" : "found",
            "Enter a word..." : "Enter a word...",
            "Validate" : "Validate",
            "Skip" : "Skip",
            "Correct answer!" : "Correct answer!",
            "Now identify the real artists" : "Now identify the real artists",
            "Your Name" : "Your Name",
            "Quiz finished!" : "Quiz finished!",
            "You scored" : "You scored",
            "Compare your score with other players!" : "Compare your score with other players!",
            "Leaderboard" : "Leaderboard",
            "Please enter a name" : "Please enter a name",
            "The name is already in use" : "The name is already in use",
            "Score saved!" : "Score saved!",
            "No scores available for today." : "No scores available for today.",
            "Daily Podium" : "Daily Podium",
            "words" : "words",
            "Other players" : "Other players",
            "Today's song" : "Today's song",
            "Find today's song to unlock the quiz!" : "Find today's song to unlock the quiz!",
            "Today's quiz" : "Today's quiz",
            "Streak (Consecutive days)" : "Streak (Consecutive days)",
            "Days played" : "Days played",
            "Max score" : "Max score",
            "Average score" : "Average score",
            "Average words" : "Average words",
            "Personal History" : "Personal History",
            "No history available" : "No history available",
            "Home" : "Home",
            "History" : "History",
            "Total score: " : "Total score: ",
            "Your Statistics" : "Your Statistics",
            "What is the release year of this song?" : "What is the release year of this song?",
            "What is the album of this song?" : "What is the album of this song?",
            "What is the birth year of the artist?" : "What is the birth year of the artist?",
            "What is the death year of the artist?" : "What is the death year of the artist?",
            "What is the formation year of the band?" : "What is the formation year of the band?",
            "What is the disbandment year of the band?" : "What is the disbandment year of the band?",
            "Which country is this artist from?" : "Which country is this artist from?",
            "What are the most popular songs of this artist?" : "What are the most popular songs of this artist?",
            "Find the two intruder songs" : "Find the two intruder songs",
            "Daily" : "Daily",
            "place_1" : "1st",
            "place_2" : "2nd",
            "place_3" : "3rd",
            "place_other" : "{{place}}th",
            "Each day, find the song of the day in as few tries as possible" : "Each day, find the song of the day in as few tries as possible",
            "Once found, take a quiz about the artist to earn bonus points" : "Once found, take a quiz about the artist to earn bonus points",
            "Compare your score with others and check the daily leaderboard" : "Compare your score with others and check the daily leaderboard",
            "Daily Mode" : "Daily Mode",
            
        },
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "fr",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;